<template>
  <div class="input">
    <label v-if="label" :for="fieldMeta.id" class="input__label">{{ label }}</label>

    <textarea
      v-if="textarea"
      :id="fieldMeta.id"
      :value="computedValue"
      :name="fieldMeta.name"
      :class="fieldClassName"
      @input="onInput"
      @blur="$emit('validate')"
    />

    <input
      v-else
      :id="fieldMeta.id"
      :name="fieldMeta.name"
      type="text"
      :value="computedValue"
      :class="fieldClassName"
      @input="onInput"
      @blur="$emit('validate')"
    />
    <p v-if="error" class="input__error">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    id: { type: String, default: null },
    name: { type: String, default: null },
    label: { type: String, default: null },
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    inputClass: { type: [String, Array, Object], default: Array },
    textarea: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { type: String, default: null },
  },
  data() {
    const id = this.id

    return {
      fieldMeta: { id, name: this.name || id },
    }
  },
  computed: {
    fieldClassName() {
      return ['input__field', this.inputClass, { '-error': this.error, '-textarea': this.textarea }]
    },
    computedValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
  },
  methods: {
    onInput({ target }) {
      const value = target.value
      this.$emit('update:modelValue', value)
      this.$emit('input', value)
    },
  },
}
</script>
